// fix with jquery
lightcase = require('vendor/lightcase');
require('lightcase/src/scss/lightcase.scss');

require('owlcarousel/owl-carousel/owl.carousel.js');
require('owlcarousel/owl-carousel/owl.carousel.css');
require('owlcarousel/owl-carousel/owl.transitions.css');

function initIndex()
{

	//$('#home-page-tabs li:first, #index .tab-content ul:first').addClass('active');

	// EXTERNAL LINKS
	$('.ext').attr('target', '_blank');


	//SOCIAL LINKS
	$('.top_socialsharing button').on('click', function(){
		type = $(this).attr('data-type');

		if( typeof sharing_name == 'undefined' || !sharing_name )
			sharing_name = document.title;

		if( typeof sharing_url == 'undefined' || !sharing_url )
			sharing_url = window.location.href;

		if (type.length)
		{
			switch(type)
			{
				case 'twitter':
					window.open('https://twitter.com/intent/tweet?text=' + sharing_name + ' ' + encodeURIComponent(sharing_url), 'sharertwt', 'toolbar=0,status=0,width=640,height=445');
					break;
				case 'facebook':
					window.open('http://www.facebook.com/sharer.php?u=' + sharing_url, 'sharer', 'toolbar=0,status=0,width=660,height=445');
					break;
				case 'google-plus':
					window.open('https://plus.google.com/share?url=' + sharing_url, 'sharer', 'toolbar=0,status=0,width=660,height=445');
					break;
				case 'pinterest':
					var img_url = sharing_img;
					if (typeof $("#bigpic").attr('src') != 'undefined' && $("#bigpic").attr('src') != '') {
						img_url = $("#bigpic").attr('src');
					}
					window.open('http://www.pinterest.com/pin/create/button/?media=' + img_url + '&url=' + sharing_url, 'sharerpinterest', 'toolbar=0,status=0,width=660,height=445');
					break;
			}
		}
	});

	// HP Slider
	if (typeof(homeslider_pause) == 'undefined')
		homeslider_pause = 3000;

	$('#homepage-slider').owlCarousel({
		loop: true,
		autoPlay : homeslider_pause,
		//autoplayTimeout: homeslider_pause,
		rewindNav : true,
	    navigation : true,
	    navigationText : ["<i class='icon-sigma icon_prev'></i>", "<i class='icon-sigma icon_next'></i>"],
	    //pagination : visual_composer_carousel.data('pagination'),
	    singleItem : true,
	    transitionStyle : "fade",
	    addClassActive: true,
	    mouseDrag : true,
	    touchDrag: true,
	    lazyLoad: false,
	    autoHeight: false,
	    afterInit: function() {
	    	$('.owl-item img').addClass('lazypreload');
	    },
	    // afterAction: function( slider ){

	    // }
	});

	// HP Content
	$('.wpb_sigma_image_content').on('click', function(e){
		e.preventDefault();
		window.location.href = $(this).parent().find('a:first').attr('href');
	});

	//TABS WIDGET
	if( $('.tab-widget').length ){

		$('.tab-widget .tab_title a').on('click', function(e){
			e.preventDefault();

			var $container = $(this).parents('.tab-widget');

			$container.find('.tab_title a').removeClass('active');
			$container.find('.tab_content').removeClass('active');

			var target = $(this).attr('href');
			$(this).addClass('active');
			$( target ).addClass('active');

		});
	}

	//LIGHTBOX
    $('a[data-rel^=lightcase]').lightcase({
        swipe: true,
        shrinkFactor: 0.95,
        maxHeight: 1500,
        maxWidth: 1500,
        showSequenceInfo: false,
        showTitle: false,
        showCaption: false
    });


    // TOP SEARCH
    $('#top_search_btn').on('click', function(e){
    	e.preventDefault();
    	$('#search_block_top').toggleClass('active');
    });

    $('#mobile_search_btn').on('click', function(e){
    	e.preventDefault();
    	$('#search_block_top').toggleClass('active');
    });

	$('#search_block_top .close').on('click', function(e){
		e.preventDefault();
		$('#search_block_top').toggleClass('active');
	});

    $("div#mega_blog").empty();
    $(".hp_blog_widget li:first-child").clone().appendTo("div#mega_blog");
    $("div#mega_blog .hp_blog_content").remove();

}

module.exports = initIndex;


// WEBPACK FOOTER //
// ./js/index.js